module.exports = __webpack_public_path__ + "img/polycarbonate-vertical.f114b4cc.jpg";